import { render, staticRenderFns } from "./HejinSchool.vue?vue&type=template&id=58c1526a&scoped=true&"
import script from "./HejinSchool.vue?vue&type=script&lang=js&"
export * from "./HejinSchool.vue?vue&type=script&lang=js&"
import style0 from "./HejinSchool.vue?vue&type=style&index=0&id=58c1526a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c1526a",
  null
  
)

export default component.exports